"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _companyappApi = require("@/api/companyappApi");
var _config = _interopRequireDefault(require("./config.vue"));
var _save = _interopRequireDefault(require("./save.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SearchTerm',
  components: {
    SearchTermSave: _save.default,
    SearchTermConfig: _config.default
  },
  data: function data() {
    return {
      listLoading: false,
      companyAppLoading: false,
      companyAppOptions: [],
      sourceMap: {
        1: '系统生成',
        2: '手动新增'
      },
      statusMap: {
        1: '启用',
        0: '禁用'
      },
      tableFrom: {
        page: 1,
        limit: 10,
        term: '',
        companyAppId: '',
        source: '',
        status: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.getList();
    this.searchCompanyAppOptions('');
  },
  methods: {
    getList: function getList(page) {
      var _this = this;
      if (page) this.tableFrom.page = page;
      this.listLoading = true;
      var params = _objectSpread(_objectSpread({}, this.tableFrom), {}, {
        term: (this.tableFrom.term || '').trim()
      });
      Object.keys(params).forEach(function (key) {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      (0, _marketing.searchTermListApi)(params).then(function (res) {
        _this.tableData = {
          data: res.list || res.data || [],
          total: res.total || 0
        };
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.tableFrom = {
        page: 1,
        limit: this.tableFrom.limit,
        term: '',
        companyAppId: '',
        source: '',
        status: ''
      };
      this.getList();
    },
    handleTermSearch: function handleTermSearch(term) {
      if (!term) return;
      this.tableFrom.term = term;
      this.getList(1);
    },
    searchCompanyAppOptions: function searchCompanyAppOptions(keyword) {
      var _this2 = this;
      this.companyAppLoading = true;
      (0, _companyappApi.companyappAutoListApi)({
        keyword: keyword || ''
      }).then(function (res) {
        _this2.companyAppOptions = res || [];
        _this2.companyAppLoading = false;
      }).catch(function () {
        _this2.companyAppLoading = false;
      });
    },
    handleCompanyAppVisibleChange: function handleCompanyAppVisibleChange(visible) {
      if (visible && !this.companyAppOptions.length) {
        this.searchCompanyAppOptions('');
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleStatusChange: function handleStatusChange(row) {
      var _this3 = this;
      var status = row.status;
      (0, _marketing.searchTermStatusApi)({
        id: row.id,
        status: status
      }).then(function () {
        _this3.$message.success('状态修改成功');
      }).catch(function () {
        row.status = status === 1 ? 0 : 1;
      });
    },
    handleConfig: function handleConfig() {
      this.$refs.SearchTermConfigRef.initOpen();
    },
    handleAdd: function handleAdd() {
      this.$refs.SearchTermSaveRef.initOpen();
    },
    handleEdit: function handleEdit(row) {
      var _this4 = this;
      if (!row || !row.id) return;
      (0, _marketing.searchTermInfoApi)(row.id).then(function (res) {
        _this4.$refs.SearchTermSaveRef.initOpen(res || {}, 'edit');
      });
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;
      if (!row || !row.id) return;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u70ED\u641C\u8BCD\u300C".concat(row.term || '', "\u300D\uFF1F"), '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _marketing.searchTermDeleteApi)(row.id).then(function () {
          _this5.$message.success('删除成功');
          _this5.getList(1);
        });
      }).catch(function () {});
    }
  }
};